import * as React from "react";
import { ListGroup } from "components/bootstrap";
import SortableListItem from "./SortableListItem";
const List = ({
  alignItemContent = void 0,
  customContentRender = void 0,
  customListItemRender = void 0,
  disableDragging = false,
  items
}) => /* @__PURE__ */ React.createElement(ListGroup, null, items == null ? void 0 : items.map((item, index) => /* @__PURE__ */ React.createElement(
  SortableListItem,
  {
    alignItemContent,
    customContentRender,
    customListItemRender,
    disableDragging,
    index,
    item,
    key: item.id
  }
)));
export default React.memo(List);
